export default "__VITE_ASSET__cb8cdc42__"